"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M6 21h12V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'DeleteSharp');